import { Component, OnInit, ChangeDetectorRef, TemplateRef, QueryList, ViewChildren } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MasterService } from "../master/services/master-service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { CommonHelper } from "src/app/helper/helper.component";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { DatePipe } from '@angular/common';
import { GrievanceDetailsService } from '../../shared/grievance-details-popup/grievance-details.service'
import { GrievanceViewService } from '../../shared/grievance-time-line-details/grievance-time-line-details.service';
import { UpdateActionService } from "src/app/shared/update-action/update-action.service";
import { DataTableDirective } from 'angular-datatables';
declare var $: any;


@Component({
  selector: 'app-real-time-dashboard',
  templateUrl: './real-time-dashboard.component.html',
  styleUrls: ['./real-time-dashboard.component.scss'],
  providers: [MasterService, CommonHelper, DatePipe]
})
export class RealTimeDashboardComponent implements OnInit {

  dataTable: any;
  modalRef: BsModalRef;
  allGreviancesData: any;
  isAllGrievanceDataExists: boolean = false;
  isPendingExists: boolean = false;
  isClosedDataExists: boolean = false;
  registerGrievancesData: any;
  pendingGreviancesData: any;
  closedGrevianceData: any;
  districtsData: any;
  categoryData: any;
  levelData: any
  beneficaryStatusDetails: any;
  categoriesNature: any;
  adminDashBoardForm: FormGroup;
  grieveanceDetailsData: any
  realTimeData: any;
  filterDataColor: any;
  modalBool: boolean = false;
  modalDetails: boolean = false;
  modalView: boolean = false;
  grievanceHistoryData: any;
  actionTakenData: Array<any> = [];
  fileUploadData: Array<any> = [];
  acceptedGrievanceCount: number;
  isGrievanceCountExists: boolean = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;

  data: any = {
    district_id: '',
    complain_id: '',
    start_date: '',//2023 - 04 - 03
    end_date: '',//2023 - 04 - 10
    color: '',
    level: '',
  }
  data1: any = {
    state_id: '',
    complain_id: '',
    start_date: '',//2023 - 04 - 03
    end_date: '',//2023 - 04 - 10
    color: '',
    level: '',
  }

  maxDate: any = new Date();
  showPickerStart = false;
  submitted: boolean = false;
  startDateTime: Date = null;
  endDateTime: Date = null;
  showPickerEnd = false;
  showDateEnd = true;
  showTimeEnd = true;
  showDateStart = true;
  showTimeStart = true;
  closeButtonStart: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  closeButtonEnd: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  dtOptions: DataTables.Settings[] = [];
  currentpage: number = 1;
  acceptedGrievanceData: any = [];
  roleId: any;
  stateId: any;
  colorData: any;
  isacceptedGrievanceCountExists: boolean = false;
  stateData: any;
  language: any;

  filterdata:
    {
      district_id?: string;
      state_id?: string;
      complain_id: string;
      start_date: Date;//2023 - 04 - 03
      end_date: Date;//2023 - 04 - 10
      color: string;
      level: string;
    };



  constructor(
    private spinner: NgxSpinnerService,
    private masterService: MasterService,
    private chRef: ChangeDetectorRef,
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private grievanceDetailsPopupModal: GrievanceDetailsService,
    private grievanceViewService: GrievanceViewService,
    private updateActionService: UpdateActionService,
    private commonHelper: CommonHelper

  ) {

  }

  ngOnInit() {
    this.getLocalData();

    let apiUrl = "state-wise/grievance-list";

    this.getDistricts(this.stateId);
    this.colorDroupDown();


    this.getStates();
    if (this.roleId == 3) {
      this.getData(apiUrl, this.data, this.language);
    } else if (this.roleId == 1) {
      this.getData(apiUrl, this.data1, this.language);
    } else if (this.roleId == 5) {
      this.getData(apiUrl, this.data1, this.language);
    }

    this.validationsForFilters();
    this.getStatus();
    this.getLevels();
    //reloading the entire page on every 5-min
    setInterval(() => {
      if (window.location.pathname === '/real-time-dashboard') {
        window.location.reload();
      }
    }, 300000)
  }
  refreshData() {
    let apiUrl = "state-wise/grievance-list";
    if (this.roleId == 3) {
      this.getData(apiUrl, this.data, this.language);
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
    } else if (this.roleId == 1) {
      this.getData(apiUrl, this.data1, this.language);
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });

    } else if (this.roleId == 5) {
      this.getData(apiUrl, this.data1, this.language);
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
    }
  }

  // languageChange(event: any) {
  //   let apiUrl: 'state-wise/grievance-list';
  //   this.language = event

  //   if (this.language == 'hn' || this.language == 'en') {
  //     if (this.roleId == 3) {
  //       this.getData('state-wise/grievance-list', this.data, this.language);
  //     } else if (this.roleId == 1) {
  //       this.getData('state-wise/grievance-list', this.data1, this.language);
  //     } else if (this.roleId == 5) {
  //       this.getData('state-wise/grievance-list', this.data1, this.language);
  //     }
  //   }

  // }

  public getLocalData(): void {
    this.roleId = localStorage.getItem('roleId');
    this.stateId = localStorage.getItem('stateId');
    this.language = localStorage.getItem('language');
  }



  getStatus() {
    this.beneficaryStatusDetails = [
      { id: '', color: "", name: "", dpname: "All" },
      { id: 1, color: "White", name: "withInSevenDays", dpname: "Within 7 days" },
      { id: 2, color: "Yellow", name: "processing", dpname: "Processing" },
      { id: 3, color: "Red", name: "notRedressed", dpname: "Not Redressed within 7 days" },
      { id: 4, color: "Green", name: "redressed", dpname: "Redressed" }
    ];
  }

  getStates() {
    this.masterService.getAll('active_states').subscribe(
      (response: any) => {
        if (response.status == 200) {
          response.data.unshift({
            description: "",
            grievanceTypeId: "",
            name: 'All',
            status: 'active'
          })
          this.stateData = response.data;
        } else {
          this.stateData = [];
        }
      });
  }

  /**getCategory
   *
   *
   */
  getCategory() {
    this.apiCallingNoState("active_grievanceType");
  }
  /**getGrievanceNature
   *
   * @param stateId
   */
  getGrievanceNature(stateId) {
    this.apiCalling("active_grievanceNature", stateId);
  }

  /**GetDistricts
   *
   * @param stateId
   */
  getDistricts(stateId: number) {
    this.apiCalling("active_districts", stateId);
  }

  getLevels() {
    try {
      this.masterService.getAll('active_levels').subscribe(response => {
        if (response) {
          this.levelData = response['data']['levels'];

        } else {
          this.levelData = [];
        }

      });
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /**
   *
   * @param url
   * @param id
   */
  apiCalling(url: string, id: number) {
    try {
      this.spinner.show();
      this.masterService.getData(url + "/", id).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /**
 *
 * @param url
 * @param id
 */
  apiCallingNoState(url: string) {
    try {
      this.spinner.show();
      this.masterService.getAll(url).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  clear() {
    this.adminDashBoardForm.reset();
  }

  /**Databinding to UI
   *
   * @param url
   * @param response
   */
  dataBinding(url: string, response: any) {
    if (url === "active_districts") {
      if (response.data[0].districts.length > 0) {
        this.spinner.hide();
        response.data[0].districts.push({
          code: 'all',
          description: "",
          displayName: "All",
          districtId: "",
          name: 'All',
          status: 'active'
        })
        response.data[0].districts.sort(function (a, b) { return a.districtId - b.districtId });
        this.districtsData = response.data[0].districts;
      } else {
        this.districtsData = [];
        this.spinner.hide();
      }
    } else if (url === "active_states") {
      if (response.data.length > 0) {
        this.spinner.hide();
        response.data[0].states.push({
          description: "",
          grievanceTypeId: "",
          name: 'all',
          status: 'active'
        })

      } else {
        this.spinner.hide();
        this.levelData = [];
      }
    } else if (url === "active_grievanceNature") {
      let newData = [];
      response.data.filter((newResponse: any) => {
        newData.push({
          id: newResponse.grievanceNatureId,
          name: newResponse.grievanceNatureName
        });
      });
      if (newData.length > 0) {
        this.spinner.hide();
        this.categoriesNature = newData;
      } else {
        this.spinner.hide();
        this.categoriesNature = [];
      }
    }
  }

  validationsForFilters() {
    this.adminDashBoardForm = this.fb.group({
      selectedState: [],
      selectedDistrict: [],
      selectedComplaintId: [],
      selectedColor: [],
      selectedLevel: [],
      startDateTime: [''],
      endDateTime: ['']
    });
  }

  colorDroupDown() {
    this.colorData = [
      {
        id: 'white',
        color: 'New within 30 days'
      },
      {
        id: 'yellow',
        color: 'Processing Within 15 Days'
      },
      {
        id: 'amber',
        color: 'Processing Within 30 Days'
      },
      {
        id: 'red',
        color: 'NotRedressed Within 30 Days'
      },
      {
        id: 'green',
        color: 'Redressed'
      }


    ]
  }


  filteredData: any;

  getClass(complaint): string {

    if (complaint.color == 'white') {
      return 'white';
    } else if (complaint.color == 'yellow') {
      return 'yellow';
    } else if (complaint.color == 'amber') {
      return 'amber';
    } else if (complaint.color == 'red') {
      return 'red';
    } else if (complaint.color == 'green') {
      return 'green';
    }
  }


  /*getData bind table data */
  getData(apiRoute: string, data: any, value: string) {
    const that = this;
    const url = value == 'hn' ? '//cdn.datatables.net/plug-ins/1.10.19/i18n/Hindi.json' : '//cdn.datatables.net/plug-ins/1.10.19/i18n/English.json';
    if (data.district_id == null) {
      data.district_id = "";
    }
    if (data.complain_id == null) {
      data.complain_id = "";
    }

    if (data.color === null) {
      data.color = '';
    }
    if (data.color === undefined) {
      data.color = '';
    }

    if (data.level === null) {
      data.level = '';
    }
    if (data.level === undefined) {
      data.level = '';
    }
    if (data.start_date == null) {
      data.start_date = "";
    }
    if (data.start_date == undefined) {
      data.start_date = "";
    }
    if (data.end_date == null) {
      data.end_date = "";
    }
    if (data.end_date == undefined) {
      data.end_date = "";
    }

    if (data.state_id == null) {
      data.state_id = "";
    }


    if (this.roleId == 1) {
      this.filterdata = {
        'state_id': data.state_id,
        'complain_id': data.complain_id,
        'color': data.color,
        'level': data.level.levelId ? data.level.levelId : '',
        'start_date': data.start_date,
        'end_date': data.end_date,
      }


      try {

        this.dtOptions[0] = {
          pagingType: 'full_numbers',
          responsive: true,
          serverSide: true,
          processing: false,
          searching: true, // add search bar
          destroy: true, //Add to allow the datatable to destroy
          order: [],
          language: {
            // url: url,
            searchPlaceholder: 'Subject Of Complaint',

          },

          ajax: (dataTablesParameters: any, callback) => {

            that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
            that.masterService.postData(apiRoute + '?page=' + dataTablesParameters.length + '&currentpage=' + this.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
              (response: any) => {
                if (response) {
                  this.spinner.hide();
                  if (response.status == 200) {
                    this.isGrievanceCountExists = true;
                    this.filterDataColor = response.data;
                    this.chRef.detectChanges();

                  } else {
                    this.spinner.hide();
                    this.filterDataColor = [];
                    this.isGrievanceCountExists = false;
                    if (this.filterDataColor.length === 0) {
                      this.isGrievanceCountExists = true;
                    }

                    this.chRef.detectChanges();

                  }
                }
                callback({
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                  data: []
                });
              },
              error => {
                this.spinner.hide();
              }
            );
          },
          columns: [

          ]
        }
      } catch (excp) {
        this.spinner.hide();
      }


    } else if (this.roleId == 3) {
      this.filterdata = {
        'district_id': data.district_id,
        'complain_id': data.complain_id,
        'color': data.color,
        'level': data.level.levelId ? data.level.levelId : '',
        'start_date': data.start_date,
        'end_date': data.end_date,
      }
      this.spinner.show();
      try {
        this.dtOptions[0] = {
          pagingType: 'full_numbers',
          responsive: true,
          serverSide: true,
          processing: false,
          searching: true, // add search bar
          destroy: true, //Add to allow the datatable to destroy
          order: [],
          language: {
            // url: url,
            searchPlaceholder: 'Subject Of Complaint',

          },


          ajax: (dataTablesParameters: any, callback) => {

            that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
            that.masterService.postData(apiRoute + '?page=' + dataTablesParameters.length + '&currentpage=' + this.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
              (response: any) => {
                if (response) {
                  this.spinner.hide();
                  if (response.status == 200) {
                    this.isGrievanceCountExists = true;
                    this.filterDataColor = response.data;
                    this.chRef.detectChanges();

                  } else {
                    this.spinner.hide();
                    this.filterDataColor = [];
                    this.isGrievanceCountExists = false;
                    if (this.filterDataColor.length === 0) {
                      this.isGrievanceCountExists = true;
                    }

                    this.chRef.detectChanges();

                  }
                }
                callback({
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                  data: []
                });
              },
              error => {
                this.spinner.hide();
              }
            );
          },
          columns: [

          ]
        }
      } catch (excp) {
        this.spinner.hide();
      }
    } else if (this.roleId == 5) {
      this.filterdata = {
        'state_id': data.state_id,
        'complain_id': data.complain_id,
        'color': data.color,
        'level': data.level.levelId ? data.level.levelId : '',
        'start_date': data.start_date,
        'end_date': data.end_date,
      }
      this.spinner.show()
      try {
        this.dtOptions[0] = {
          pagingType: 'full_numbers',
          responsive: true,
          serverSide: true,
          processing: false,
          searching: true, // add search bar
          destroy: true, //Add to allow the datatable to destroy
          order: [],
          language: {
            // url: url,
            searchPlaceholder: 'Subject Of Complaint',

          },

          ajax: (dataTablesParameters: any, callback) => {

            that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
            that.masterService.postData(apiRoute + '?page=' + dataTablesParameters.length + '&currentpage=' + this.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
              (response: any) => {
                if (response) {
                  this.spinner.hide();
                  if (response.status == 200) {
                    this.isGrievanceCountExists = true;
                    this.filterDataColor = response.data;
                    this.chRef.detectChanges();

                  } else {
                    this.spinner.hide();
                    this.filterDataColor = [];
                    this.isGrievanceCountExists = false;
                    if (this.filterDataColor.length === 0) {
                      this.isGrievanceCountExists = true;
                    }

                    this.chRef.detectChanges();

                  }
                }
                callback({
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                  data: []
                });
              },
              error => {
                this.spinner.hide();
              }
            );
          },
          columns: [

          ]
        }

      } catch (excp) {
        this.spinner.hide();
      }
    }


  }


  // language changes in table 
  chageTableLangage(language) {
    const table: any = $("#dataTable1");

    if (language == 'en') {
      this.dataTable = table.DataTable(
        { "order": [[1, "desc"]] },
        {
          language: {
            "emptyTable": "No data available in table",
            "info": "Showing _START_ to _END_ of _TOTAL_ entries",
            "infoEmpty": "Showing 0 to 0 of 0 entries",
            "infoFiltered": "(filtered from _MAX_ total entries)",
            "lengthMenu": "Show _MENU_ entries",
            "loadingRecords": "Loading...",
            "processing": "Processing...",
            "search": "Search:",
            "zeroRecords": "No matching records found",
            "paginate": {
              "first": "First",
              "last": "Last",
              "next": "Next",
              "previous": "Previous"
            },
            "aria": {
              "sortAscending": ": activate to sort column ascending",
              "sortDescending": ": activate to sort column descending"
            }
          }
        }
      ).draw();
    } else {
      this.dataTable = table.DataTable(
        {
          language: {
            "emptyTable": "तालिका में कोई डेटा उपलब्ध नहीं है",
            "info": "कुल _TOTAL_ एंट्रीज़ में से _START_ से _END_ तक दिखा रहे हैं",
            "infoEmpty": "कुल 0 एंट्रीज़ में से 0 से 0 तक दिखा रहे हैं",
            "infoFiltered": "(_MAX_ एंट्रीज़ से फ़िल्टर किए गए)",
            "lengthMenu": "_MENU_ एंट्रीज़ दिखाएं",
            "loadingRecords": "लोड हो रहा है...",
            "processing": "प्रसंस्करण...",
            "search": "खोजें:",
            "zeroRecords": "कोई मिलान नहीं मिला",
            "paginate": {
              "first": "पहला",
              "last": "अंतिम",
              "next": "अगला",
              "previous": "पिछला"
            },
            "aria": {
              "sortAscending": ": आरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें",
              "sortDescending": ": अवरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें"
            }
          }
        })
    }
  }


  filterData(filterType: string) {
    this.data = {
      district_id: '',
      complain_id: '',
      start_date: '',//2023 - 04 - 03
      end_date: '',//2023 - 04 - 10
      color: filterType,
      level: '',
    }
    this.getData('state-wise/grievance-list', this.data, this.language);
    setTimeout(() => {
      this.dtElements.forEach((dtElement: DataTableDirective) => {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      });
    });
  }

  /*redraw the datatable*/
  reploatingDataTable() {
    let table = $("#dataTable1").DataTable();
    table.destroy();
  }

  /* Function for Opening the View Model*/
  openViewModal() {
    this.grievanceViewService.open();
  }
  /*route grievance history screen */
  viewTimeLineGrievance(id) {
    this.modalView = true;
    if (this.roleId == 1) {
      this.masterService.getData("grievance_history/", id).subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.spinner.hide();
            this.grievanceHistoryData = response.data;
            this.masterService.getGrievanceDetails('grievance/view?grievanceId=', id).subscribe((response: any) => {
              if (response.status == 200) {
                this.openViewModal();
                let apiUrl = "state-wise/grievance-list";

                this.getData(apiUrl, this.data, this.language);
                setTimeout(() => {
                  this.dtElements.forEach((dtElement: DataTableDirective) => {
                    dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                      dtInstance.draw();
                    });
                  });
                });
              }
            });
          } else {
            this.spinner.hide();
            this.grievanceHistoryData = [];
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } else if (this.roleId == 3) {
      this.masterService.getData("grievance_history/", id).subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.spinner.hide();
            this.grievanceHistoryData = response.data;
            this.masterService.getGrievanceDetails('grievance/view?grievanceId=', id).subscribe((response: any) => {
              if (response.status == 200) {
                this.openViewModal();
                let apiUrl = "state-wise/grievance-list";
                this.getData(apiUrl, this.data1, this.language);
                setTimeout(() => {
                  this.dtElements.forEach((dtElement: DataTableDirective) => {
                    dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                      dtInstance.draw();
                    });
                  });
                });
              }
            });
          } else {
            this.spinner.hide();
            this.grievanceHistoryData = [];
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } else if (this.roleId == 5) {
      this.masterService.getData("grievance_history/", id).subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.spinner.hide();
            this.grievanceHistoryData = response.data;
            this.masterService.getGrievanceDetails('grievance/view?grievanceId=', id).subscribe((response: any) => {
              if (response.status == 200) {
                this.openViewModal();
                let apiUrl = "state-wise/grievance-list";

                this.getData(apiUrl, this.data, this.language);
                setTimeout(() => {
                  this.dtElements.forEach((dtElement: DataTableDirective) => {
                    dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                      dtInstance.draw();
                    });
                  });
                });
              }
            });
          } else {
            this.spinner.hide();
            this.grievanceHistoryData = [];
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    }

  }


  openDetailsModal() {
    this.grievanceDetailsPopupModal.open();
  }

  /* Showing grievance Modal Popup on click of grievamce Id*/
  grievanceDetailsModal(grievanceId) {
    this.modalDetails = true;
    if (this.roleId == 1) {
      this.masterService.getGrievanceDetails('grievance_details/', grievanceId).subscribe(
        (response: any) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.grieveanceDetailsData = response.data[0];
              this.masterService.getGrievanceDetails('grievance/view?grievanceId=', grievanceId).subscribe((response: any) => {
                if (response.status == 200) {
                  this.openDetailsModal();
                  let apiUrl = "state-wise/grievance-list";
                  this.getData(apiUrl, this.data, this.language);
                  setTimeout(() => {
                    this.dtElements.forEach((dtElement: DataTableDirective) => {
                      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                        dtInstance.draw();
                      });
                    });
                  });
                }
              });

            }
          } else {
            this.spinner.hide();
            this.grieveanceDetailsData = [];
          }

        },
        error => {
          this.spinner.hide();
        }
      );
    } else if (this.roleId == 3) {
      this.masterService.getGrievanceDetails('grievance_details/', grievanceId).subscribe(
        (response: any) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.grieveanceDetailsData = response.data[0];
              this.masterService.getGrievanceDetails('grievance/view?grievanceId=', grievanceId).subscribe((response: any) => {
                if (response.status == 200) {
                  this.openDetailsModal();
                  let apiUrl = "state-wise/grievance-list";
                  this.getData(apiUrl, this.data1, this.language);
                  setTimeout(() => {
                    this.dtElements.forEach((dtElement: DataTableDirective) => {
                      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                        dtInstance.draw();
                      });
                    });
                  });
                }
              });
            }
          } else {
            this.spinner.hide();
            this.grieveanceDetailsData = [];
          }

        },
        error => {
          this.spinner.hide();
        }
      );
    } if (this.roleId == 5) {
      this.masterService.getGrievanceDetails('grievance_details/', grievanceId).subscribe(
        (response: any) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.grieveanceDetailsData = response.data[0];
              this.masterService.getGrievanceDetails('grievance/view?grievanceId=', grievanceId).subscribe((response: any) => {
                if (response.status == 200) {
                  this.openDetailsModal();
                  let apiUrl = "state-wise/grievance-list";
                  this.getData(apiUrl, this.data, this.language);
                  setTimeout(() => {
                    this.dtElements.forEach((dtElement: DataTableDirective) => {
                      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                        dtInstance.draw();
                      });
                    });
                  });
                }
              });
            }
          } else {
            this.spinner.hide();
            this.grieveanceDetailsData = [];
          }

        },
        error => {
          this.spinner.hide();
        }
      );
    }
  }

  openUpdateAction() {
    this.updateActionService.open();
  }
  grieveanceUpdateData: any;
  modalUpdate: boolean = false;
  /* Showing grievance update Modal Popup on click of grievamce Id*/
  grievanceUpdateActionModal(grievanceId) {
    this.modalUpdate = true;

    if (this.roleId == 1) {
      this.masterService.getGrievanceDetails('grievance_details/', grievanceId).subscribe(
        (response: any) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.grieveanceUpdateData = response.data[0];
              this.masterService.getGrievanceDetails('grievance/view?grievanceId=', grievanceId).subscribe((response: any) => {
                if (response.status == 200) {
                  this.openUpdateAction();
                  let apiUrl = "state-wise/grievance-list";
                  this.getData(apiUrl, this.data, this.language);
                  setTimeout(() => {
                    this.dtElements.forEach((dtElement: DataTableDirective) => {
                      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                        dtInstance.draw();
                      });
                    });
                  });
                }
              });
            }
          } else {
            this.spinner.hide();
            this.grieveanceUpdateData = [];
          }

        },
        error => {
          this.spinner.hide();
        }
      );
    } else if (this.roleId == 3) {
      this.masterService.getGrievanceDetails('grievance_details/', grievanceId).subscribe(
        (response: any) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.grieveanceUpdateData = response.data[0];
              this.masterService.getGrievanceDetails('grievance/view?grievanceId=', grievanceId).subscribe((response: any) => {
                if (response.status == 200) {
                  this.openUpdateAction();
                  let apiUrl = "state-wise/grievance-list";
                  this.getData(apiUrl, this.data1, this.language);
                  setTimeout(() => {
                    this.dtElements.forEach((dtElement: DataTableDirective) => {
                      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                        dtInstance.draw();
                      });
                    });
                  });
                }
              });
            }
          } else {
            this.spinner.hide();
            this.grieveanceUpdateData = [];
          }

        },
        error => {
          this.spinner.hide();
        }
      );
    } else if (this.roleId == 5) {
      this.masterService.getGrievanceDetails('grievance_details/', grievanceId).subscribe(
        (response: any) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.grieveanceUpdateData = response.data[0];
              this.masterService.getGrievanceDetails('grievance/view?grievanceId=', grievanceId).subscribe((response: any) => {
                if (response.status == 200) {
                  this.openUpdateAction();
                  let apiUrl = "state-wise/grievance-list";
                  this.getData(apiUrl, this.data, this.language);
                  setTimeout(() => {
                    this.dtElements.forEach((dtElement: DataTableDirective) => {
                      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                        dtInstance.draw();
                      });
                    });
                  });
                }
              });
            }
          } else {
            this.spinner.hide();
            this.grieveanceUpdateData = [];
          }

        },
        error => {
          this.spinner.hide();
        }
      );
    }


  }

  /* Submit the filter*/
  submitReport() {
    let apiData = this.adminDashBoardForm.value;

    if (apiData.selectedDistrict == null) {
      apiData.selectedDistrict = "";
    }
    if (apiData.selectedComplaintId == null) {
      apiData.selectedComplaintId = "";
    }

    if (apiData.selectedColor == null) {
      apiData.selectedColor = "";
    }
    if (apiData.selectedColor == undefined) {
      apiData.selectedColor = "";
    }

    if (apiData.selectedLevel == null) {
      apiData.selectedLevel = "";
    }
    if (apiData.startDateTime == null) {
      apiData.startDateTime = "";
    }
    if (apiData.endDateTime == null) {
      apiData.endDateTime = "";
    }
    if (apiData.selectedState == null) {
      apiData.selectedState = "";
    }


    if (this.roleId == 1) {
      this.data = {
        state_id: apiData.selectedState.id,
        complain_id: apiData.selectedComplaintId,
        start_date: apiData.startDateTime,//2023 - 04 - 03
        end_date: apiData.endDateTime,//2023 - 04 - 10
        color: apiData.selectedColor.id,
        level: apiData.selectedLevel,
      }
      let apiUrl = "state-wise/grievance-list";

      this.getData('state-wise/grievance-list', this.data, this.language);
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
    } else if (this.roleId == 3) {
      this.data = {
        district_id: apiData.selectedDistrict,
        complain_id: apiData.selectedComplaintId,
        start_date: apiData.startDateTime,//2023 - 04 - 03
        end_date: apiData.endDateTime,//2023 - 04 - 10
        color: apiData.selectedColor.id,
        level: apiData.selectedLevel,
      }
      let apiUrl = "state-wise/grievance-list";

      this.getData(apiUrl, this.data, this.language);
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
      this.spinner.hide()

    } else if (this.roleId == 5) {
      this.data = {
        state_id: apiData.selectedState.id,
        complain_id: apiData.selectedComplaintId,
        start_date: apiData.startDateTime,//2023 - 04 - 03
        end_date: apiData.endDateTime,//2023 - 04 - 10
        color: apiData.selectedColor.id,
        level: apiData.selectedLevel,
      }
      let apiUrl = "state-wise/grievance-list";

      this.getData(apiUrl, this.data, this.language);
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
      this.spinner.hide()

    }
  }

  // function to append value in input 
  onValueChange(val: any, endorstart: string) {
    if (endorstart === 'startDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd HH:mm:ss")
      this.startDateTime = val;
      this.submitted = false;
    }
    if (endorstart === 'endDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd HH:mm:ss")
      this.endDateTime = val;
      this.submitted = false;
    }
  }

  // toggle function to show datetime picker modal
  onTogglePicker(value: string) {
    if (value == 'startDT') {
      if (!this.showPickerStart) {
        this.showPickerStart = true;

      }
    }
    if (value == 'endDT') {
      if (!this.showPickerEnd) {
        this.showPickerEnd = true;
      }
    }
  }


  /* Function for Opening the Password Popup Model*/
  openModal() {
    this.grievanceDetailsPopupModal.open();
  }

  /*getData bind table data */
  getFiles(id) {
    try {
      this.spinner.show();
      this.openModal();
      this.masterService.getAll('grievance_uploads/' + id).subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.actionTakenData = response.data;
            this.actionTakenData.map(item => {
              if (item.isGrievanceRedressed == 1) {
                item.isGrievanceRedressedVal = "Yes";
              } else {
                item.isGrievanceRedressedVal = "No"
              }
              this.fileUploadData = item.uploads
            })

          } else {
            this.spinner.hide();
            this.actionTakenData = [];
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (exc) {
      this.spinner.hide();
    }
  }
}
